const faqItems = [
  {
    q: '五一吃瓜网是什么？',
    a: '五一吃瓜网是一个专注网红黑料与网络热门事件追踪的吃瓜爆料平台，每日更新最新扒皮帖、翻车实锤和塌房现场，覆盖娱乐圈、直播圈、短视频圈等多个领域，为吃瓜群众提供一站式热点追踪服务。',
  },
  {
    q: '五一吃瓜网的内容多久更新一次？',
    a: '我们的编辑团队 24 小时轮班值守，实时监控全网热点动态。爆料内容每日滚动更新，重大事件发生后 15 分钟内即可上线相关追踪报道，确保你不错过任何一个热瓜。',
  },
  {
    q: '如何找到五一吃瓜网的最新地址？',
    a: '五一吃瓜网提供永久官网入口，建议将本站加入浏览器收藏夹。如遇访问异常，可通过页脚邮箱联系我们获取最新可用地址，或关注我们的微博、抖音官方账号获取实时通知。',
  },
  {
    q: '五一吃瓜网的爆料内容可信吗？',
    a: '我们建立了严格的多源交叉验证机制，每条爆料均需至少 2 个独立信源佐证后方可发布。同时标注信息来源与可信度等级，让瓜友们吃得明白、吃得放心。',
  },
  {
    q: '可以投稿爆料吗？我能获得什么？',
    a: '当然可以！欢迎通过本站投稿入口提交你的独家爆料。审核通过的高质量爆料将给予现金奖励，长期合作的优质爆料者还可获得平台认证标识与额外流量扶持。',
  },
  {
    q: '五一吃瓜网有APP吗？如何下载？',
    a: '有的！五一吃瓜网APP已上线，支持 iOS 和 Android 双平台。APP 端提供推送通知、离线阅读、夜间模式等专属功能，扫描页面底部二维码或在应用商店搜索「五一吃瓜」即可下载。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-20 md:py-28 bg-background-700">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 text-center mb-14">
          吃瓜必读：爆料问答
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-400 rounded-2xl p-8 hover:bg-background-800 transition-colors duration-300 group cursor-default"
            >
              <h3 className="text-lg font-bold text-foreground-950 mb-3 font-heading group-hover:text-accent-800 transition-colors duration-200">
                {item.q}
              </h3>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}